import * as stylex from "@stylexjs/stylex";

export default function () {
    return (
        <svg display="none">
            <symbol id="flame-ico" viewBox="0 0 16 16" fill="currentColor">
                <path d="M6.69,1c.08,1.49-.37,2.36-1.34,4.18-.43.8-.95,1.8-1.58,3.12-1.12,2.26-.6,5,1.27,6.69-1.12-5.1,2.22-7.07,2.26-7.09.09-.05.2-.05.29,0,.09.06.14.16.12.26-.09,1.75.35,3.48,1.28,4.96.54-.27,1.06-.59,1.55-.95.08-.06.2-.07.29-.02.09.05.15.14.16.25-.06.86-.19,1.71-.41,2.54,1.02-1.05,1.75-2.34,2.13-3.75.28-1.57,0-3.19-.77-4.58-.12,1.72-.81,3.35-1.95,4.64-.1.11-.28.12-.39.02h0c-.11-.1-.13-.28-.03-.39.05-.06.09-.12.12-.19.19-.38.6-1.56.37-4.45-.23-2.18-1.48-4.13-3.36-5.25h-.01Z" />
            </symbol>

            <symbol
                id="heartBorderSymbol"
                viewBox="0 0 24 24"
                {...stylex.props(svgStyles.roundStrokeNoFill, svgStyles.strokeWidth2)}
            >
                <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
            </symbol>

            <symbol id="likecounter" viewBox="0 0 22.48 21.77">
                <path d="M21.087 7.446a3.906 3.906 0 00-2.536-.945h-3.226V4.492A4.371 4.371 0 0013.712.734 4.828 4.828 0 009.755.209a1.631 1.631 0 00-1.142 1.555v3.523a2.371 2.371 0 01-1.149 1.97 5.227 5.227 0 01-1.02.564 2.4 2.4 0 00-1.3-.381H2.399a2.4 2.4 0 00-2.4 2.4v9.008a2.4 2.4 0 002.4 2.4h2.757a2.34 2.34 0 00.86-.16 3.91 3.91 0 002.211.685h8.629a4.872 4.872 0 002.728-.76 4.063 4.063 0 001.732-2.94l1.113-6.924a4.031 4.031 0 00-1.342-3.703zM2.4 19.423a.575.575 0 01-.576-.576V9.839a.578.578 0 01.576-.578h2.745a.559.559 0 01.265.068l-.2 10.075c-.017 0-.032.019-.051.019zm18.232-8.566l-1.12 6.953a2.278 2.278 0 01-.945 1.688 3.063 3.063 0 01-1.71.449H8.228a2.082 2.082 0 01-1.2-.425l.2-10.058a7.088 7.088 0 001.295-.729 4.176 4.176 0 001.909-3.45l-.131-3.34a2.98 2.98 0 012.33.255 2.679 2.679 0 01.87 2.291v3.831h5.048a2.079 2.079 0 011.351.508 2.2 2.2 0 01.73 2.027z" />
            </symbol>

            <symbol id="lksmbl" viewBox="0 0 50 47.24">
                <path d="M50 22.53v.07L47.1 41c-.51 4-3.23 6.23-7.66 6.23H18a6.12 6.12 0 0 1-3-.73V19.16c2.5-1.07 7.36-3.89 7.36-9.46V.93a.57.57 0 0 1 .41-.54A9.57 9.57 0 0 1 25.55 0a6.51 6.51 0 0 1 4 1.18c1.73 1.26 2.61 3.46 2.61 6.54v8.51h11.52a6.31 6.31 0 0 1 6.32 6.3Zm-40-3.3V46.3a2.57 2.57 0 0 1-.87.15h-6.4A2.73 2.73 0 0 1 0 43.72V21.81a2.73 2.73 0 0 1 2.73-2.73h6.35a2.61 2.61 0 0 1 .92.15Z" />
            </symbol>

            <symbol id="locationIconSymbol" viewBox="0 0 24 24" {...stylex.props(svgStyles.roundStroke)}>
                <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" />
                <circle cx="12" cy="10" r="3" />
            </symbol>

            <symbol id="pencilsymbol" viewBox="0 0 20 20" stroke="#fff" fill="none" strokeWidth="1.8">
                <path strokeMiterlimit="10" d="M9.71 3.9L3.9 9.71" />
                <path
                    d="M18.41 19.48a.94.94 0 001.07-1.07l-.17-4.61a1.23 1.23 0 00-.35-.64L6.76 1A1.46 1.46 0 004.7.92L.92 4.7A1.46 1.46 0 001 6.76L13.16 19a1.23 1.23 0 00.64.35z"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </symbol>

            <symbol id="closeIconSlim" viewBox="0 0 50 50" {...stylex.props(svgStyles.roundStrokeCaps)}>
                <path d="M46.92 47.17 2.73 2.98M46.92 2.98 2.73 47.17" />
            </symbol>

            <symbol id="loadingIcon" viewBox="0 0 100 100" strokeWidth="12" fill="transparent">
                <circle r="20" cx="50" cy="50" />
                <circle r="45" cx="50" cy="50" strokeDasharray="60 223" stroke="#DC2664" />
            </symbol>
            <symbol
                id="search-v2"
                viewBox="0 0 50 50"
                {...stylex.props(svgStyles.roundStroke, svgStyles.strokeWidth3)}
            >
                <path d="M46.48,23.35A21.72,21.72,0,1,1,24.76,1.64,21.67,21.67,0,0,1,46.48,23.35Z" />
                <line x1="46.95" y1="48.36" x2="39.4" y2="39.87" />
                <path d="M24.76,37.74A13.45,13.45,0,0,1,11.31,24.29" />
                <path d="M13,16.79a7.76,7.76,0,0,1,8.28-7.2" />
            </symbol>

            <symbol id="arrow-left" viewBox="0 0 24 24" {...stylex.props(svgStyles.roundStroke)}>
                <path d="m12 19-7-7 7-7" />
                <path d="M19 12H5" />
            </symbol>

            <symbol id="arrow-right" viewBox="0 0 24 24" {...stylex.props(svgStyles.roundStroke)}>
                <path d="M5 12h14" />
                <path d="m12 5 7 7-7 7" />
            </symbol>

            <symbol id="cashbackLabel" viewBox="0 0 192.3 192.3" fill="white">
                <circle cx="95.1" cy="95.9" r="92.5" fill="#dc2664" />
                <path d="M137.2 143.1A62.2 62.2 0 1 1 93.7 36.2v-3.9c-18 0-34.8 7.1-47.3 19.9a65.6 65.6 0 0 0 .6 92.9 66 66 0 0 0 45.1 19.4h1.6a65.8 65.8 0 0 0 66.1-66.1H156a62 62 0 0 1-18.8 44.7z" />
                <path d="m142.7 70.1-13.1-5.3-4.2 10.3 19.9 8.1 10.3 4.2 1.8-4.4L168 57.2 157.7 53 153 64.5a58.6 58.6 0 0 0-45.4-34.1L106 41.9a47.3 47.3 0 0 1 36.7 28.2zM67.7 78.6c-2.3-1.2-5-1.8-8.1-1.8h-16v42.8H52v-15.1h7.4c4.9 0 8.7-1.2 11.4-3.6 2.7-2.4 4.1-5.7 4.1-9.9a14 14 0 0 0-1.9-7.4c-1.2-2.2-3-3.9-5.3-5zm-3 17.1c-1.2 1.1-2.9 1.6-5.1 1.6H52V83.9h7.7c2.1 0 3.7.7 4.9 2 1.2 1.3 1.8 3 1.8 5.1 0 2.1-.5 3.6-1.7 4.7z" />
                <path d="M77.7 76.8 77.7 119.6 104.1 119.6 104.1 112.5 86.2 112.5 86.2 76.8z" />
                <path d="M114.9 76.8 106.4 76.8 106.4 119.6 114.9 119.6 114.9 91.4 131.3 119.6 139.7 119.6 139.7 89.5 131.3 85.9 131.3 105z" />
            </symbol>

            <symbol id="chevron-right" viewBox="0 0 24 24" {...stylex.props(svgStyles.roundStroke)}>
                <path d="m9 18 6-6-6-6" />
            </symbol>

            <symbol id="chevron-left" viewBox="0 0 24 24" {...stylex.props(svgStyles.roundStroke)}>
                <path d="m15 18-6-6 6-6" />
            </symbol>

            <svg id="chevron-bottom" viewBox="0 0 24 24" {...stylex.props(svgStyles.roundStroke)}>
                <path d="m6 9 6 6 6-6" />
            </svg>

            <svg id="chevron-up" viewBox="0 0 24 24" {...stylex.props(svgStyles.roundStroke)}>
                <path d="m18 15-6-6-6 6" />
            </svg>
        </svg>
    );
}

export const svgStyles = stylex.create({
    roundStroke: {
        fill: "transparent",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
    },

    roundStrokeNoFill: {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
    },

    roundStrokeCaps: {
        stroke: "currentColor",
        strokeLinecap: "round",
    },

    strokeWidth2: {
        strokeWidth: 2,
    },

    strokeWidth3: {
        strokeWidth: 3,
    },
});
